import React from "react";
import { Card, CardContent } from "@/components/ui/card";

export function Meta({ label, value, tone = "default" }) {
  const toneCls = tone === "red" ? "text-red-700" : "text-zinc-900";
  return (
    <div>
      <div className="label-overline">{label}</div>
      <div className={`font-mono mt-0.5 ${toneCls}`}>{value}</div>
    </div>
  );
}

export function Kpi({ label, value, testId }) {
  return (
    <div className="rounded-sm border border-zinc-200 bg-white p-4" data-testid={testId}>
      <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 mb-1.5">{label}</div>
      <div className="font-display font-bold text-xl tracking-tight text-zinc-900">{value}</div>
    </div>
  );
}

export function Th({ children, right }) {
  return (
    <th className={`px-3 py-2 text-[10px] uppercase tracking-wider text-zinc-500 font-semibold ${right ? "text-right" : "text-left"}`}>
      {children}
    </th>
  );
}

export function Td({ children, right, mono, className = "" }) {
  return (
    <td className={`px-3 py-2 ${right ? "text-right" : "text-left"} ${mono ? "font-mono" : ""} ${className}`}>
      {children}
    </td>
  );
}

export function HierarchyCard({ title, rows, cols, testId, emptyMsg }) {
  return (
    <Card className="rounded-sm border-zinc-200" data-testid={testId}>
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-2">
          <div className="label-overline">{title}</div>
          <span className="text-[10px] font-mono text-zinc-400">{rows.length} rows</span>
        </div>
        {rows.length === 0 ? (
          <div className="text-xs italic text-zinc-500 py-4 text-center">{emptyMsg}</div>
        ) : (
          <div className="max-h-[360px] overflow-y-auto">
            <table className="w-full text-xs">
              <tbody>
                {rows.slice(0, 100).map((r, i) => (
                  <tr key={r.id || r.openai_campaign_id || r.openai_ad_group_id || r.openai_ad_id || `row-${i}`}
                      className="border-b border-zinc-50">
                    {cols.map((c) => (
                      <td key={c.key}
                        className={`px-2 py-1.5 ${c.mono === false ? "" : "font-mono text-[11px]"} truncate max-w-[200px]`}>
                        {String(r[c.key] ?? "—")}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
